import { colors } from './colors';

export const foundations = {
  palette: colors,
};
